module.exports = {
  'ABS': require('./ABS.json'),
  'ACC': require('./ACC.json'),
  'ADD': require('./ADD.json'),
  'AFF': require('./AFF.json'),
  'AIG': require('./AIG.json'),
  'AIL': require('./AIL.json'),
  'AIP': require('./AIP.json'),
  'AIS': require('./AIS.json'),
  'AL1': require('./AL1.json'),
  'APR': require('./APR.json'),
  'ARQ': require('./ARQ.json'),
  'AUT': require('./AUT.json'),
  'BHS': require('./BHS.json'),
  'BLC': require('./BLC.json'),
  'BLG': require('./BLG.json'),
  'BPO': require('./BPO.json'),
  'BPX': require('./BPX.json'),
  'BTS': require('./BTS.json'),
  'BTX': require('./BTX.json'),
  'CDM': require('./CDM.json'),
  'CER': require('./CER.json'),
  'CM0': require('./CM0.json'),
  'CM1': require('./CM1.json'),
  'CM2': require('./CM2.json'),
  'CNS': require('./CNS.json'),
  'CON': require('./CON.json'),
  'CSP': require('./CSP.json'),
  'CSR': require('./CSR.json'),
  'CSS': require('./CSS.json'),
  'CTD': require('./CTD.json'),
  'CTI': require('./CTI.json'),
  'DB1': require('./DB1.json'),
  'DG1': require('./DG1.json'),
  'DRG': require('./DRG.json'),
  'DSC': require('./DSC.json'),
  'DSP': require('./DSP.json'),
  'ECD': require('./ECD.json'),
  'ECR': require('./ECR.json'),
  'EDU': require('./EDU.json'),
  'EQL': require('./EQL.json'),
  'EQP': require('./EQP.json'),
  'EQU': require('./EQU.json'),
  'ERQ': require('./ERQ.json'),
  'ERR': require('./ERR.json'),
  'EVN': require('./EVN.json'),
  'FAC': require('./FAC.json'),
  'FHS': require('./FHS.json'),
  'FT1': require('./FT1.json'),
  'FTS': require('./FTS.json'),
  'GOL': require('./GOL.json'),
  'GP1': require('./GP1.json'),
  'GP2': require('./GP2.json'),
  'GT1': require('./GT1.json'),
  'IAM': require('./IAM.json'),
  'IIM': require('./IIM.json'),
  'ILT': require('./ILT.json'),
  'IN1': require('./IN1.json'),
  'IN2': require('./IN2.json'),
  'IN3': require('./IN3.json'),
  'INV': require('./INV.json'),
  'IPC': require('./IPC.json'),
  'ISD': require('./ISD.json'),
  'ITM': require('./ITM.json'),
  'IVT': require('./IVT.json'),
  'LAN': require('./LAN.json'),
  'LCC': require('./LCC.json'),
  'LCH': require('./LCH.json'),
  'LDP': require('./LDP.json'),
  'LOC': require('./LOC.json'),
  'LRL': require('./LRL.json'),
  'MFA': require('./MFA.json'),
  'MFE': require('./MFE.json'),
  'MFI': require('./MFI.json'),
  'MRG': require('./MRG.json'),
  'MSA': require('./MSA.json'),
  'MSH': require('./MSH.json'),
  'NCK': require('./NCK.json'),
  'NDS': require('./NDS.json'),
  'NK1': require('./NK1.json'),
  'NPU': require('./NPU.json'),
  'NSC': require('./NSC.json'),
  'NST': require('./NST.json'),
  'NTE': require('./NTE.json'),
  'OBR': require('./OBR.json'),
  'OBX': require('./OBX.json'),
  'ODS': require('./ODS.json'),
  'ODT': require('./ODT.json'),
  'OM1': require('./OM1.json'),
  'OM2': require('./OM2.json'),
  'OM3': require('./OM3.json'),
  'OM4': require('./OM4.json'),
  'OM5': require('./OM5.json'),
  'OM6': require('./OM6.json'),
  'OM7': require('./OM7.json'),
  'ORC': require('./ORC.json'),
  'ORG': require('./ORG.json'),
  'OVR': require('./OVR.json'),
  'PCE': require('./PCE.json'),
  'PCR': require('./PCR.json'),
  'PD1': require('./PD1.json'),
  'PDA': require('./PDA.json'),
  'PDC': require('./PDC.json'),
  'PEO': require('./PEO.json'),
  'PES': require('./PES.json'),
  'PID': require('./PID.json'),
  'PKG': require('./PKG.json'),
  'PR1': require('./PR1.json'),
  'PRA': require('./PRA.json'),
  'PRB': require('./PRB.json'),
  'PRC': require('./PRC.json'),
  'PRD': require('./PRD.json'),
  'PSH': require('./PSH.json'),
  'PTH': require('./PTH.json'),
  'PV1': require('./PV1.json'),
  'PV2': require('./PV2.json'),
  'QAK': require('./QAK.json'),
  'QID': require('./QID.json'),
  'QPD': require('./QPD.json'),
  'QRD': require('./QRD.json'),
  'QRF': require('./QRF.json'),
  'QRI': require('./QRI.json'),
  'RCP': require('./RCP.json'),
  'RDF': require('./RDF.json'),
  'RDT': require('./RDT.json'),
  'RF1': require('./RF1.json'),
  'RGS': require('./RGS.json'),
  'RMI': require('./RMI.json'),
  'ROL': require('./ROL.json'),
  'RQ1': require('./RQ1.json'),
  'RQD': require('./RQD.json'),
  'RXA': require('./RXA.json'),
  'RXC': require('./RXC.json'),
  'RXD': require('./RXD.json'),
  'RXE': require('./RXE.json'),
  'RXG': require('./RXG.json'),
  'RXO': require('./RXO.json'),
  'RXR': require('./RXR.json'),
  'SAC': require('./SAC.json'),
  'SCH': require('./SCH.json'),
  'SFT': require('./SFT.json'),
  'SID': require('./SID.json'),
  'SPM': require('./SPM.json'),
  'SPR': require('./SPR.json'),
  'STF': require('./STF.json'),
  'STZ': require('./STZ.json'),
  'TCC': require('./TCC.json'),
  'TCD': require('./TCD.json'),
  'TQ1': require('./TQ1.json'),
  'TQ2': require('./TQ2.json'),
  'TXA': require('./TXA.json'),
  'UB1': require('./UB1.json'),
  'UB2': require('./UB2.json'),
  'URD': require('./URD.json'),
  'URS': require('./URS.json'),
  'VAR': require('./VAR.json'),
  'VND': require('./VND.json'),
  'VTQ': require('./VTQ.json'),
};